/**
 * FeaturePath: 會員系統-購物車-願望清單
 * Accountable: AlexCH Cheng, Landy Chu
 */

export const SET_LIST = 'SET_WISHES_LIST';
